"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
require("antd/lib/modal/style");
var _modal = _interopRequireDefault(require("antd/lib/modal"));
require("antd/lib/icon/style");
var _icon = _interopRequireDefault(require("antd/lib/icon"));
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
require("antd/lib/col/style");
var _col = _interopRequireDefault(require("antd/lib/col"));
require("antd/lib/card/style");
var _card = _interopRequireDefault(require("antd/lib/card"));
require("antd/lib/input/style");
var _input = _interopRequireDefault(require("antd/lib/input"));
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
require("antd/lib/select/style");
var _select = _interopRequireDefault(require("antd/lib/select"));
require("antd/lib/form/style");
var _form = _interopRequireDefault(require("antd/lib/form"));
var _react = _interopRequireWildcard(require("react"));
var _antdMaskInput = _interopRequireDefault(require("antd-mask-input"));
var _lodash = require("lodash");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _AddLicense = _interopRequireDefault(require("./AddLicense"));
var _utils = require("../../../utils");
var _ = require("../..");
var _components = require("../../../components");
require("./ClinicianInfoForm.less");
var _ClinicianProviderPerStateEligibility = _interopRequireDefault(require("./ClinicianProviderPerStateEligibility"));
var _api = require("./api");
var _excluded = ["upload"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FormItem = _form.default.Item;
var Option = _select.default.Option;
var Title = _typography.default.Title,
  Text = _typography.default.Text;
var eRxIdValidator = (0, _utils.eRxIdValidator)();
var phoneValidator = (0, _utils.phoneValidator)();
var urlValidator = (0, _utils.urlValidator)();
var npiValidator = (0, _utils.npiNumberValidator)();
var UsaStates = _utils.UsaStatesUtils.UsaStates;
var formatClinicianData = function formatClinicianData(clinician) {
  return _objectSpread(_objectSpread({}, clinician), {}, {
    rate: (0, _utils.parsePriceNumToFormString)(clinician.rate),
    groupSessionRate: (0, _utils.parsePriceNumToFormString)(clinician.groupSessionRate),
    terminationDate: clinician.terminationDate ? (0, _utils.formatDateField)(clinician.terminationDate) : '',
    credentialedDate: clinician.credentialedDate ? (0, _utils.formatDateField)(clinician.credentialedDate) : '',
    experienceYears: (0, _lodash.toString)(clinician.experienceYears)
  });
};
var possibleTimeZones = process.env.REACT_APP_ENVIRONMENT !== _utils.AppEnvironment.Production ? (0, _utils.getTimeZonesInCountries)(['US', 'UA']) : (0, _utils.getTimeZonesInCountries)(['US']);
var ClinicianInfoForm = function ClinicianInfoForm(_ref) {
  var _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$isLicenseEditabl = _ref.isLicenseEditable,
    isLicenseEditable = _ref$isLicenseEditabl === void 0 ? false : _ref$isLicenseEditabl,
    form = _ref.form,
    clinician = _ref.clinician,
    _ref$showErxInput = _ref.showErxInput,
    showErxInput = _ref$showErxInput === void 0 ? false : _ref$showErxInput,
    _ref$showRateInput = _ref.showRateInput,
    showRateInput = _ref$showRateInput === void 0 ? false : _ref$showRateInput,
    onSubmit = _ref.onSubmit,
    _ref$isAdmin = _ref.isAdmin,
    isAdmin = _ref$isAdmin === void 0 ? false : _ref$isAdmin,
    _ref$refreshClinician = _ref.refreshClinician,
    refreshClinician = _ref$refreshClinician === void 0 ? _lodash.noop : _ref$refreshClinician;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalVisible = _useState2[0],
    setModalVisible = _useState2[1];
  var getFieldDecorator = form.getFieldDecorator,
    resetFields = form.resetFields,
    setFieldsValue = form.setFieldsValue,
    validateFieldsAndScroll = form.validateFieldsAndScroll;
  var imageValidators = [(0, _.maxImageSizeValidator)(20, 'Please use ID image with size less than 20 Mb'), (0, _.isAllowedTypeValidator)(_utils.ACCEPT_IMAGE_TYPES, function (file, fileType) {
    return (0, _.composeAcceptedFileTypesText)(_utils.ACCEPT_IMAGE_TYPES, fileType);
  })];
  var formattedClinician = formatClinicianData(clinician);
  var scheduleOnceLabelValidator = (0, _react.useMemo)(function () {
    return (0, _utils.fieldValidator)('scheduleoncelabel', {
      skippedValue: formattedClinician.scheduleOnceLabel
    });
  }, [formattedClinician.scheduleOnceLabel]);
  var generateId = function generateId() {
    return "".concat(+new Date());
  };
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    licenses = _useState4[0],
    setLicenses = _useState4[1];
  var _useUpdateMedicareEli = (0, _api.useUpdateMedicareEligibility)(clinician.id, {
      onSuccess: refreshClinician
    }),
    saveMedicareEligibleStates = _useUpdateMedicareEli.save,
    savingMedicare = _useUpdateMedicareEli.saving;
  var _useUpdateMedicaidEli = (0, _api.useUpdateMedicaidEligibility)(clinician.id, {
      onSuccess: refreshClinician
    }),
    saveMedicaidEligibleStates = _useUpdateMedicaidEli.save,
    savingMedicaid = _useUpdateMedicaidEli.saving;
  var addLicense = function addLicense(license) {
    setLicenses([].concat(_toConsumableArray(licenses), [_objectSpread(_objectSpread({}, license), {}, {
      key: generateId(),
      editable: true
    })]));
    onCancel();
  };
  var deleteLicense = function deleteLicense(key) {
    var data = licenses.filter(function (l) {
      return l.key !== key;
    });
    setLicenses(data);
  };
  var onModalOpen = function onModalOpen() {
    setModalVisible(true);
  };
  var onCancel = function onCancel() {
    setModalVisible(false);
  };
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    validateFieldsAndScroll(function (err, formValues) {
      if (err) {
        return;
      }

      // Only get values that have changed
      var data = (0, _lodash.pickBy)(formValues, function (value, key) {
        if (value === formattedClinician[key]) {
          return false;
        }

        // Sometimes values get converted to empty strings
        var trimmedValue = (0, _lodash.trim)(value);
        if (trimmedValue === (0, _lodash.toString)(formattedClinician[key])) {
          return false;
        }
        return true;
      });
      if (data.experienceYears) {
        data.experienceYears = parseInt(data.experienceYears, 10);
      }
      if (data.rate) {
        data.rate = (0, _utils.parsePriceFormStringToNum)(data.rate);
      }
      if (data.groupSessionRate) {
        data.groupSessionRate = (0, _utils.parsePriceFormStringToNum)(data.groupSessionRate);
      }
      if (!(0, _lodash.isEmpty)(licenses)) {
        data.licenses = licenses.map(function (_ref2) {
          var key = _ref2.key,
            id = _ref2.id;
          return _objectSpread(_objectSpread({}, formValues.licenses[key]), {}, {
            id: id
          });
        });
      }
      if (isAdmin) {
        // Admins can set and delete clinician termination, credentialed dates and credentialing notes
        // It should be written back as null, if the field is empty
        if (data.terminationDate === '') {
          data.terminationDate = null;
        }
        if (data.credentialedDate === '') {
          data.credentialedDate = null;
        }
        if (data.credentialingNote === '') {
          data.credentialingNote = null;
        }
      }
      var file = data.upload,
        values = _objectWithoutProperties(data, _excluded);
      onSubmit({
        values: values,
        file: file
      });
      resetFields();
    });
  };
  (0, _react.useEffect)(function () {
    setFieldsValue(formatClinicianData(clinician));
  }, [clinician, setFieldsValue]);
  (0, _react.useEffect)(function () {
    var _clinician$licenses;
    if ((_clinician$licenses = clinician.licenses) !== null && _clinician$licenses !== void 0 && _clinician$licenses.length) {
      setLicenses(clinician.licenses.map(function (l) {
        return _objectSpread(_objectSpread({}, l), {}, {
          editable: isLicenseEditable,
          key: l.id
        });
      }));
    } else {
      setLicenses([]);
    }
  }, [clinician.licenses, isLicenseEditable]);
  return /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: isLoading,
    size: "large"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ClinicalInfoForm mb-30"
  }, /*#__PURE__*/_react.default.createElement(_form.default, {
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react.default.createElement(_row.default, {
    gutter: 30
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 24,
    md: 12
  }, /*#__PURE__*/_react.default.createElement(_card.default, {
    className: "custom-card PersonalInfo ant-card-inner",
    title: /*#__PURE__*/_react.default.createElement(Title, {
      level: 4
    }, "Personal info"),
    bordered: false
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(FormItem, {
    className: "floating-label"
  }, getFieldDecorator('firstName', {
    initialValue: formattedClinician.firstName,
    rules: [{
      required: true,
      message: 'Please enter a first name'
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "First name",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(FormItem, {
    className: "floating-label"
  }, getFieldDecorator('middleName', {
    initialValue: formattedClinician.middleName
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "Middle name",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(FormItem, {
    className: "floating-label"
  }, getFieldDecorator('lastName', {
    initialValue: formattedClinician.lastName,
    rules: [{
      required: true,
      message: 'Please enter a last name'
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "Last name",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(FormItem, {
    className: "floating-label"
  }, getFieldDecorator('phoneNumber', {
    initialValue: formattedClinician.phoneNumber,
    getValueFromEvent: function getValueFromEvent(e) {
      var val = e.target.value;
      return val && "".concat(val).replace(/[()\s-]/g, '').slice(0, 10);
    },
    rules: [{
      validator: phoneValidator
    }]
  })( /*#__PURE__*/_react.default.createElement(_antdMaskInput.default, {
    mask: "(111) 111-1111",
    name: "phone",
    placeholder: "(123) 456-7890",
    addonAfter: "Phone",
    size: "large",
    onChange: function onChange(e) {
      return _defineProperty({}, e.target.name, e.target.value);
    }
  }))), /*#__PURE__*/_react.default.createElement(FormItem, {
    className: "floating-label"
  }, getFieldDecorator('timeZone', {
    initialValue: formattedClinician.timeZone
  })( /*#__PURE__*/_react.default.createElement(_select.default, {
    placeholder: "Time Zone",
    showSearch: true
  }, possibleTimeZones.map(function (zone, key) {
    return /*#__PURE__*/_react.default.createElement(Option, {
      key: key,
      value: zone
    }, zone);
  })))), /*#__PURE__*/_react.default.createElement(FormItem, {
    className: "floating-label"
  }, getFieldDecorator('npiNumber', {
    initialValue: formattedClinician.npiNumber,
    rules: [{
      validator: npiValidator
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "NPI",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(FormItem, {
    className: "floating-label"
  }, getFieldDecorator('calendarUrl', {
    initialValue: formattedClinician.calendarUrl,
    rules: [{
      validator: urlValidator
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    name: "calendarUrl",
    placeholder: "https://calendar.link",
    addonAfter: "Calendar Link",
    size: "large",
    onChange: function onChange(e) {
      return _defineProperty({}, e.target.name, e.target.value);
    }
  }))), /*#__PURE__*/_react.default.createElement(FormItem, {
    className: "floating-label"
  }, getFieldDecorator('scheduleOnceLabel', {
    initialValue: formattedClinician.scheduleOnceLabel,
    rules: [{
      validator: scheduleOnceLabelValidator
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    name: "scheduleOnceLabel",
    placeholder: "Clinician Name",
    addonAfter: "ScheduleOnce Label",
    size: "large",
    onChange: function onChange(e) {
      return _defineProperty({}, e.target.name, e.target.value);
    }
  }))), /*#__PURE__*/_react.default.createElement(FormItem, {
    className: "floating-label"
  }, getFieldDecorator('payTo', {
    initialValue: formattedClinician.payTo
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    name: "payTo",
    placeholder: "LLC identifier",
    addonAfter: "Pay To",
    size: "large",
    onChange: function onChange(e) {
      return _defineProperty({}, e.target.name, e.target.value);
    },
    disabled: !isAdmin
  }))), showErxInput && /*#__PURE__*/_react.default.createElement(FormItem, {
    className: "floating-label"
  }, getFieldDecorator('erxId', {
    initialValue: formattedClinician.erxId,
    rules: [{
      required: true,
      message: 'Please enter eRx Id'
    }, {
      validator: eRxIdValidator
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "eRx ID",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    className: "mx-auto ant-upload-row"
  }, getFieldDecorator('upload', {
    valuePropName: 'fileList'
  })( /*#__PURE__*/_react.default.createElement(_.ImageUploader, {
    imageId: formattedClinician.image,
    validators: imageValidators,
    viewMode: _.UploaderViewModes.LABELLED_CARD,
    previewImageSrc: (0, _utils.getCdnBucketImageUrl)(formattedClinician.image)
  }))), /*#__PURE__*/_react.default.createElement(FormItem, null, getFieldDecorator('biography', {
    initialValue: formattedClinician.biography
  })( /*#__PURE__*/_react.default.createElement(_input.default.TextArea, {
    placeholder: "Short bio",
    className: "min-h-320",
    size: "large"
  })))))), /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 24,
    md: 12
  }, isAdmin && /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_card.default, {
    className: "custom-card ant-card-inner termination-date mb-[30px] gap-y-[20px]",
    title: /*#__PURE__*/_react.default.createElement(Title, {
      level: 4
    }, "Insurance eligibility"),
    bordered: false
  }, /*#__PURE__*/_react.default.createElement(_ClinicianProviderPerStateEligibility.default, {
    clinicianId: formattedClinician.id,
    providerName: "Medicare",
    eligibility: formattedClinician.medicareEligibility,
    saveEligibleStates: saveMedicareEligibleStates,
    savingEligibileStates: savingMedicare
  }), /*#__PURE__*/_react.default.createElement(_ClinicianProviderPerStateEligibility.default, {
    clinicianId: formattedClinician.id,
    providerName: "Medicaid",
    eligibility: formattedClinician.medicaidEligibility,
    saveEligibleStates: saveMedicaidEligibleStates,
    savingEligibileStates: savingMedicaid,
    wrapperClassName: "mt-[20px]"
  }))), /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_card.default, {
    className: "custom-card ant-card-inner Credentials",
    title: /*#__PURE__*/_react.default.createElement(Title, {
      level: 4
    }, "Credentials"),
    bordered: false
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-center"
  }, licenses.map(function (item, i) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: item.key,
      className: "license-form"
    }, /*#__PURE__*/_react.default.createElement(_row.default, {
      type: "flex",
      justify: "space-between",
      align: "middle",
      className: "license-title"
    }, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(Text, {
      strong: true
    }, "License ", i + 1, ' ', item.expirationDate && _momentTimezone.default.utc().isAfter(_momentTimezone.default.utc(item.expirationDate).add(1, 'day')) && /*#__PURE__*/_react.default.createElement(_components.MonumentTag, {
      type: "warning"
    }, "Expired"))), /*#__PURE__*/_react.default.createElement(_col.default, null, item.editable && /*#__PURE__*/_react.default.createElement(_icon.default, {
      type: "close-circle",
      theme: "filled",
      className: "text-danger",
      onClick: function onClick() {
        return deleteLicense(item.key);
      }
    }))), /*#__PURE__*/_react.default.createElement(FormItem, {
      className: "floating-label"
    }, getFieldDecorator("licenses[".concat(item.key, "].licenseName"), {
      initialValue: item.licenseName,
      rules: [{
        required: true,
        message: 'Please enter License name'
      }, _utils.whitespaceValidator]
    })( /*#__PURE__*/_react.default.createElement(_input.default, {
      addonAfter: "License name",
      size: "large",
      disabled: !item.editable
    }))), /*#__PURE__*/_react.default.createElement(_row.default, {
      type: "flex",
      justify: "space-between",
      gutter: 16
    }, /*#__PURE__*/_react.default.createElement(_col.default, {
      span: 12
    }, /*#__PURE__*/_react.default.createElement(FormItem, {
      className: "floating-label"
    }, getFieldDecorator("licenses[".concat(item.key, "].licenseType"), {
      initialValue: item.licenseType,
      rules: [{
        required: true,
        message: 'Please enter license Type'
      }, _utils.whitespaceValidator]
    })( /*#__PURE__*/_react.default.createElement(_input.default, {
      addonAfter: "Type",
      size: "large",
      disabled: !item.editable
    })))), /*#__PURE__*/_react.default.createElement(_col.default, {
      span: 12
    }, /*#__PURE__*/_react.default.createElement(FormItem, {
      className: "floating-label"
    }, getFieldDecorator("licenses[".concat(item.key, "].licenseNumber"), {
      initialValue: item.licenseNumber,
      rules: [{
        required: true,
        message: 'Please enter license Number'
      }, _utils.whitespaceValidator]
    })( /*#__PURE__*/_react.default.createElement(_input.default, {
      addonAfter: "Numbers",
      size: "large",
      disabled: !item.editable
    }))))), /*#__PURE__*/_react.default.createElement(FormItem, {
      className: "floating-label"
    }, getFieldDecorator("licenses[".concat(item.key, "].state"), {
      initialValue: item.state,
      rules: [{
        required: true,
        message: 'Please enter license State'
      }, _utils.whitespaceValidator]
    })( /*#__PURE__*/_react.default.createElement(_select.default, {
      filterOption: function filterOption(input, option) {
        return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      },
      optionFilterProp: "children",
      placeholder: "State",
      showSearch: true,
      disabled: !item.editable
    }, UsaStates.map(function (_ref7) {
      var abbreviation = _ref7.abbreviation,
        name = _ref7.name;
      return /*#__PURE__*/_react.default.createElement(Option, {
        key: abbreviation,
        value: abbreviation
      }, name);
    })))), /*#__PURE__*/_react.default.createElement(FormItem, {
      className: "floating-label material-form-item"
    }, getFieldDecorator("licenses[".concat(item.key, "].expirationDate"), {
      initialValue: item.expirationDate ? _momentTimezone.default.utc(item.expirationDate) : null
    })( /*#__PURE__*/_react.default.createElement(_.DatePicker, {
      placeholder: "MM/DD/YYYY",
      size: "large"
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: "ant-input-group-addon permanent-open"
    }, "Expiration Date")));
  }), /*#__PURE__*/_react.default.createElement(FormItem, null, /*#__PURE__*/_react.default.createElement(_components.TextButton, {
    icon: "add-heavy-16",
    iconPosition: "left",
    onClick: onModalOpen
  }, !licenses.length ? 'Add license' : 'Add another license')), /*#__PURE__*/_react.default.createElement(FormItem, {
    className: "floating-label"
  }, getFieldDecorator('educationResidency', {
    initialValue: formattedClinician.educationResidency
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "Education",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(FormItem, {
    className: "floating-label"
  }, getFieldDecorator('specialties', {
    initialValue: formattedClinician.specialties
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "Specialties",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(FormItem, {
    className: "floating-label"
  }, getFieldDecorator('experienceYears', {
    initialValue: formattedClinician.experienceYears
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    type: "number",
    addonAfter: "Years in practice",
    size: "large"
  })))))), /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_card.default, {
    className: "custom-card ant-card-inner Billing",
    title: /*#__PURE__*/_react.default.createElement(Title, {
      level: 4
    }, "Taxonomy"),
    bordered: false
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(FormItem, {
    className: "floating-label"
  }, getFieldDecorator('primaryTaxonomyCode', {
    initialValue: formattedClinician.primaryTaxonomyCode,
    rules: [{
      len: 10,
      message: 'Primary Taxonomy Code must be exactly 10 characters'
    }, {
      whitespace: true
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "Primary Taxonomy Code",
    size: "large",
    maxLength: 10
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(FormItem, {
    className: "floating-label"
  }, getFieldDecorator('secondaryTaxonomyCode', {
    initialValue: formattedClinician.secondaryTaxonomyCode,
    rules: [{
      len: 10,
      message: 'Secondary Taxonomy Code must be exactly 10 characters'
    }, {
      whitespace: true
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    addonAfter: "Secondary Taxonomy Code",
    size: "large",
    maxLength: 10
  })))))), showRateInput && /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_card.default, {
    className: "custom-card ant-card-inner Billing",
    title: /*#__PURE__*/_react.default.createElement(Title, {
      level: 4
    }, "Billing"),
    bordered: false
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(FormItem, {
    className: "floating-label"
  }, getFieldDecorator('rate', {
    initialValue: formattedClinician.rate,
    rules: [{
      validator: (0, _utils.priceValidator)()
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    placeholder: "40.00",
    addonAfter: "Rate",
    size: "large"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(FormItem, {
    className: "floating-label"
  }, getFieldDecorator('groupSessionRate', {
    initialValue: formattedClinician.groupSessionRate,
    rules: [{
      validator: (0, _utils.priceValidator)()
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    placeholder: "0.00",
    addonAfter: "Group session rate",
    size: "large"
  })))))), isAdmin && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_card.default, {
    className: "custom-card ant-card-inner termination-date mb-[30px]",
    title: /*#__PURE__*/_react.default.createElement(Title, {
      level: 4
    }, "Termination date"),
    bordered: false
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-center"
  }, getFieldDecorator('terminationDate', {
    initialValue: formattedClinician.terminationDate,
    rules: [{
      message: 'Clinician termination date',
      whitespace: true
    }, {
      validator: _utils.validOrEmptyDateInputValidator
    }]
  })( /*#__PURE__*/_react.default.createElement(_components.DateInput, {
    wrapperStyles: "mt-[0px]",
    label: "Termination date",
    form: form
  }))))), /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_card.default, {
    className: "custom-card ant-card-inner credentialed-details mb-[30px]",
    title: /*#__PURE__*/_react.default.createElement(Title, {
      level: 4
    }, "Credentialed details"),
    bordered: false
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-center"
  }, getFieldDecorator('credentialedDate', {
    initialValue: formattedClinician.credentialedDate,
    rules: [{
      message: 'Clinician credentialed date',
      whitespace: true
    }, {
      validator: _utils.validOrEmptyDateInputValidator
    }]
  })( /*#__PURE__*/_react.default.createElement(_components.DateInput, {
    wrapperStyles: "mt-[0px]",
    label: "Credentialed date",
    form: form
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(FormItem, {
    className: "floating-label"
  }, getFieldDecorator('credentialingNote', {
    initialValue: formattedClinician.credentialingNote
  })( /*#__PURE__*/_react.default.createElement(_components.TextInput, {
    wrapperStyles: "my-[30px]",
    label: "Credentialing notes",
    form: form,
    multiline: true,
    contained: true
  }))))))), /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(FormItem, {
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_components.PrimaryButton, {
    htmlType: "submit"
  }, "Save changes")))))), /*#__PURE__*/_react.default.createElement(_modal.default, {
    title: 'Add license',
    visible: modalVisible,
    onCancel: onCancel,
    footer: null
  }, /*#__PURE__*/_react.default.createElement(_AddLicense.default, {
    states: UsaStates,
    onSubmit: addLicense
  }))));
};
ClinicianInfoForm.propTypes = {
  form: _propTypes.default.object.isRequired,
  isLicenseEditable: _propTypes.default.bool,
  showErxInput: _propTypes.default.bool,
  clinician: _propTypes.default.shape({
    firstName: _propTypes.default.string,
    middleName: _propTypes.default.string,
    lastName: _propTypes.default.string,
    phoneNumber: _propTypes.default.string,
    npiNumber: _propTypes.default.string,
    erxId: _propTypes.default.string,
    biography: _propTypes.default.string,
    educationResidency: _propTypes.default.string,
    specialties: _propTypes.default.string,
    experienceYears: _propTypes.default.number,
    scheduleOnceLabel: _propTypes.default.string,
    licenses: _propTypes.default.arrayOf(_propTypes.default.shape({
      licenseName: _propTypes.default.string,
      licenseType: _propTypes.default.string,
      licenseNumber: _propTypes.default.string,
      state: _propTypes.default.string
    }))
  }),
  onSubmit: _propTypes.default.func.isRequired,
  isAdmin: _propTypes.default.bool
};
var _default = _form.default.create({
  name: 'ClinicianInfoForm'
})(ClinicianInfoForm);
exports.default = _default;